import { Fragment, ReactElement, useMemo } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { ResearchNotifications } from 'notifications-from-civil-status/view-models/notifications-list';
import SearchCancellationsForDeathNonResidentePersonSipoPage from 'cancellations/pages/cancellation-non-resident/search';

interface ResearchDeathNonResidentNotificationSharedProps {
  goBackUrl?: string;
  editSipoUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchDeathNonResidentNotificationShared = ({
  goBackUrl = '',
  editSipoUrl = '',
  redirectUrl = '',
  items = [],
}: ResearchDeathNonResidentNotificationSharedProps): ReactElement => {
  const filterTable = useFilterTable<ResearchNotifications>();

  const initialValues = useMemo(() => {
    return {
      fiscalCode: filterTable.values?.searchPersonFiscalCode,
      surname: filterTable.values?.searchPersonSurname,
      name: filterTable.values?.searchPersonName,
      birthday: filterTable.values?.searchPersonDateBorn,
    };
  }, [filterTable.values]);

  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <SearchCancellationsForDeathNonResidentePersonSipoPage
        addedTitle="Cancellazione per Morte Non Residenti"
        goBackUrl={goBackUrl}
        editSipoUrl={editSipoUrl}
        redirectUrl={redirectUrl}
        isWithoutBreadcrumb
        initialValues={initialValues}
      />
    </Fragment>
  );
};

ResearchDeathNonResidentNotificationShared.displayName =
  'Research Death Non Resident Notifications Page component';

export default ResearchDeathNonResidentNotificationShared;
